import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ContactTypeEnums } from 'src/app/enum/contact-type-enums';
import { TypeDocumentEnums } from 'src/app/enum/type-document-enums';
import { TypePersonEnums } from 'src/app/enum/type-person-enums';
import { ClientModel } from 'src/app/models/archive/client.model';
import { UpdateStateClientResponseModel } from 'src/app/models/archive/update-state-client-response.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { CityTableModalModel } from 'src/app/models/management/city-table-modal.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ClientService } from 'src/app/services/archive/client.service';
import { ConstructionSiteService } from 'src/app/services/archive/construction-site.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { ValidateEmailService } from 'src/app/services/global-services/validate-email.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ContactReferenceModalComponent } from '../../contact-reference-modal/contact-reference-modal.component';
import { UpdateDocumentClientComponent } from '../update-document-client/update-document-client.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-register-client',
  templateUrl: './register-client.component.html',
  styleUrls: ['./register-client.component.scss'],
  standalone: false
})
export class RegisterClientComponent implements OnInit {

  @ViewChild('selectCity') citySelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('changeDocumentModal') changeDocumentModalComponent?: CustomModalComponent | null = null;
  @ViewChild('clientContactModal') clientContactModalComponent?: CustomModalComponent | null = null;
  @ViewChild('clientReferenceModal') clientReferenceModalComponent?: CustomModalComponent | null = null;

  ascendant: boolean = true;
  cityId: number = 0;
  cityName: string = '';
  citySelectionData: PagedResponseModel<CityTableModalModel> = new PagedResponseModel<CityTableModalModel>();
  clientContract: ClientModel = new ClientModel();
  clientId: number = 0;
  columnSort: string | null = null;
  componentChangeDocumentModal = UpdateDocumentClientComponent;
  componentCitySelection = CustomTableSelectComponent;
  componentContactModal = ContactReferenceModalComponent;
  departmentId: number = 0;
  departmentName: string = '';
  disableUpdateDocument: boolean = false;
  disabledForm: boolean = false;
  filtersCitySelection: ColumnResponseModel[] = [];
  formClient: FormGroup = new FormGroup({});
  headersCitySelection: ColumnResponseModel[] = [];
  inputsForChangeDocumentModals$ = new BehaviorSubject<any>({
    btnDisabled: false,
    clientId: 0
  });
  inputsForContactModals$ = new BehaviorSubject<any>({
    entityId: 0,
    isContact: false,
    typeContact: ContactTypeEnums.client
  });
  inputsForSelectCityModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: true,
    showRecover: true
  });
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listClientState: any[] = [];
  listCurrency: any[] = [];
  listTypeDocument: any[] = [];
  listTypePerson: any[] = [];
  modalTitle: string = "";
  nameWindow: string = 'Captura Clientes';
  output$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  subscription: Subscription;
  typeContact: number = ContactTypeEnums.client;
  url: string = "client";
  userAuthenticated: UserModel = new UserModel();
  visibleAdvancedOptions: boolean = false;
  visibleGreatContributor: boolean = false;
  visibleState: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private clientService: ClientService,
    private constructionSiteService: ConstructionSiteService,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private validateEmailService: ValidateEmailService,
    private windowService: WindowService) {
    this.validateForm(this.clientContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.clientId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCity(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCity(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
    this.subscription?.unsubscribe();
  }

  async changeDocument() {
    const typeDocumentId = this.formClient.get("typeDocumentId")?.value;
    const document = this.formClient.get("document")?.value;
    let document2 = this.formClient.get("document2")?.value;
    if (document2 == null || document2 == "") {
      document2 = "null";
    }
    if (document != "") {
      await this.getClientByDocument(document, document2, typeDocumentId);
    } else {
      this.createNewClient();
    }
  }

  changeIvaResponsible() {
    const swIvaResponsible = this.formClient.get("swIvaResponsible")?.value;
    const swSimpleTaxRegime = this.formClient.get("swSimpleTaxRegime")?.value;
    if (swIvaResponsible && !swSimpleTaxRegime) {
      this.visibleGreatContributor = true;
    } else {
      this.visibleGreatContributor = false;
      this.formClient.controls["swGreatContributor"].setValue(false);
      this.formClient.controls["swIvaRetainer"].setValue(false);
    }
  }

  changeNames() {
    let names = this.formClient.get("names")?.value;
    let lastNames = this.formClient.get("lastNames")?.value;
    if (names == null) {
      names = '';
    } else if (lastNames == null) {
      lastNames = '';
    }
    this.formClient.controls["businessName"].setValue(`${names} ${lastNames}`);
  }

  changeState(clientStateId: number) {
    this.updateFormState(clientStateId);
  }

  changeTypePerson(typePersonId: number) {
    this.disableNamesByTypePerson(typePersonId);
    if (typePersonId == TypePersonEnums.natural) {
      this.formClient.controls["businessName"].setValue(null);
    } else if (typePersonId == TypePersonEnums.juridica) {
      this.formClient.controls["names"].setValue(null);
      this.formClient.controls["lastNames"].setValue(null);
    }
  }

  createNewClient() {
    if (!this.permissionUpdatable) {
      this.updateFormPermision();
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear clientes. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    this.clientId = 0;
    this.cityName = '';
    this.departmentName = '';
    this.visibleState = false;
    this.disableUpdateDocument = true;
    this.visibleAdvancedOptions = false;
    this.clientContract = new ClientModel();
    this.clientContract.clientId = 0;
    this.validateForm(this.clientContract);
    this.changeIvaResponsible();
    this.location.replaceState(`/${this.url}/register`);
  }

  async deleteClient() {
    if (this.clientContract.clientId == 0 || this.clientContract.clientId == null) {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear un cliente.`
      );
      return;
    }

    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar clientes. Comuníquese con el administrador del sistema.`
      );
      return;
    }

    if (await this.confirmDialogService.confirm(
      `¿Realmente desea eliminar al cliente ${this.clientContract.businessName}?`
    )) {
      try {
        await firstValueFrom(this.clientService.deleteClient(this.clientId));
        this.toastHandlerService.showToast(
          'success',
          `El cliente fue eliminado exitosamente.`
        );
        this.createNewClient();
      } catch (error) {
        console.error('Error al eliminar el cliente.', error);
      }
    }
  }

  disableNamesByTypePerson(typePersonId: number) {
    if (typePersonId == TypePersonEnums.natural) {
      setTimeout(() => {
        this.formControlStateService.setControlState(this.formClient, ['names', 'lastNames'], true);
        this.formControlStateService.setControlState(this.formClient, ['businessName', 'businessName2'], false);
      }, 100);
    } else if (typePersonId == TypePersonEnums.juridica) {
      setTimeout(() => {
        this.formControlStateService.setControlState(this.formClient, ['names', 'lastNames'], false);
        this.formControlStateService.setControlState(this.formClient, ['businessName', 'businessName2'], true);
      }, 100);
    }
  }

  async getAllCitySelectionAsync() {
    try {
      this.citySelectionData = await firstValueFrom(
        this.clientService.getCitiesAsync(
          this.page, this.limit, this.columnSort, this.ascendant, this.filtersCitySelection
        )
      );
      this.updateInputsForSelectCityModal();
    } catch (error) {
      console.error('Error al buscar las ciudades para el modal.', error);
    }
  }

  async getAllLists() {
    try {
      const [clientStates, typeDocuments, typePersons, currencies] = await Promise.all([
        firstValueFrom(this.clientService.getAllclientStatesForSelectAsync()),
        firstValueFrom(this.clientService.getAllTypeDocumentsForSelectAsync()),
        firstValueFrom(this.clientService.getAllTypePersonsForSelectAsync()),
        firstValueFrom(this.clientService.getAllCurrenciesForSelectAsync()),
      ]);

      this.listClientState = clientStates;
      this.listTypeDocument = typeDocuments;
      this.listTypePerson = typePersons;
      this.listCurrency = currencies;

      return true;
    } catch (error) {
      console.error('Error al buscar las listas.', error);
      return false;
    }
  }

  async getCityDepartment(cityId: number) {
    try {
      const cityDepartment: any = await firstValueFrom(this.clientService.getCityDepartment(cityId));
      this.cityName = cityDepartment.cityName;
      this.departmentName = cityDepartment.departmentName;
    } catch (error) {
      this.cityName = '';
      this.departmentName = '';
      console.error('Error al buscar la ciudad y el departamento.', error);
    }
  }

  async getClientByDocument(document: string, document2: string, typeDocumentId: number) {
    try {
      this.clientContract = await firstValueFrom(this.clientService.getClientByDocument(document, document2));
      this.cityId = this.clientContract.cityId;
      this.departmentId = this.clientContract.departmentId;
      this.validateForm(this.clientContract);
      this.changeIvaResponsible();
      if (this.cityId != 0) {
        this.getCityDepartment(this.cityId);
      }
      if (this.clientContract.clientId != 0) {
        this.updateFormState();
        this.disableUpdateDocument = false;
        this.visibleState = true;
        this.visibleAdvancedOptions = true;
      } else {
        this.clientContract.stateChangeDate = new Date();
        this.validateForm(this.clientContract);
        this.cityName = '';
        this.departmentName = '';
        this.formClient.controls["typeDocumentId"].setValue(typeDocumentId);
        this.formClient.controls["typePersonId"].setValue(TypePersonEnums.natural);
        this.updateFormState();
        this.disableUpdateDocument = true;
        this.visibleState = false;
        this.visibleAdvancedOptions = false;
      }
      if (!this.permissionUpdatable) {
        this.updateFormPermision();
      }
    } catch (error) {
      this.formClient.controls["digitVerification"].setValue(-1);
      this.formClient.controls["digitVerification2"].setValue(-1);
      console.error('Error al buscar el cliente por documento.', error);
    }
  }

  async getClientById() {
    try {
      this.clientContract = await firstValueFrom(this.clientService.getClientById(this.clientId));
      this.cityId = this.clientContract.cityId;
      this.departmentId = this.clientContract.departmentId;
      this.validateForm(this.clientContract);
      this.changeIvaResponsible();
      if (this.cityId != 0) {
        this.getCityDepartment(this.cityId);
      }
      if (this.permissionUpdatable) {
        this.updateFormState();
        this.disableUpdateDocument = false;
        this.visibleState = true;
        this.visibleAdvancedOptions = true;
      } else {
        this.updateFormPermision();
      }
    } catch (error) {
      console.error('Error al buscar el cliente por ID.', error);
    }
  }

  async getColumnsCitySelection() {
    try {
      if (this.headersCitySelection.length === 0) {
        this.headersCitySelection = await firstValueFrom(this.clientService.getColumnsForCitiesAsync());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para el modal.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getPermissionProfileByUrl();
    await this.getAllLists();
    this.inputsForChangeDocumentModals$.next({
      clientId: this.clientContract.clientId,
      btnDisabled: this.disableUpdateDocument
    });

  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.clientId !== null && this.clientId !== 0) {
      await this.getClientById();
    } else {
      this.createNewClient();
    }
  }

  isSameDate(date1: Date, date2: Date): boolean {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  async onFilterChangeCity(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersCitySelection = this.removeDuplicates(filters);
    this.filtersCitySelection.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForSelectCityModal();
  }

  async onPageChangeCity(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllCitySelectionAsync();
  }

  openChangeDocumentModal() {
    if (this.clientContract.clientId == 0 || this.clientContract.clientId == null) {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear un cliente.`
      );
      return;
    }

    this.changeDocumentModalComponent?.show();
  }

  async openCitySelectionModal() {
    if (this.clientContract.clientStateId !== ClientStateEnums.activo) {
      this.toastHandlerService.showToast(
        'warning',
        `Para modificar la ciudad, el cliente debe estar activo.`
      );
      return;
    }

    this.filtersCitySelection = [];
    await Promise.all([
      this.getColumnsCitySelection(),
      this.getAllCitySelectionAsync()]
    );
    this.updateInputsForSelectCityModal();
    this.citySelectionModalComponent?.show();
  }

  openContactModal(isContact: boolean) {
    this.inputsForContactModals$.next({
      entityId: this.clientContract.clientId,
      typeContact: this.typeContact, isContact: isContact
    });
    if (this.clientContract.clientId == 0 || this.clientContract.clientId == null) {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear un cliente.`
      );
      return;
    }

    if (isContact) {
      this.clientContactModalComponent?.show();
    } else {
      this.clientReferenceModalComponent?.show();
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersCitySelection = this.filtersCitySelection.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersCitySelection.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async reloadClient(reload: boolean) {
    if (reload) {
      await this.getClientById();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    this.validateFormControls();
    if (this.cityId === 0 || this.departmentId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        `El campo Ciudad y Departamento son obligatorios.`
      );
      return;
    }
    if (!this.formClient.valid) {
      this.showValidationMessages();
      return;
    }

    this.formClient.enable();
    const modelClient = this.formClient.value as ClientModel;
    modelClient.cityId = this.cityId;
    modelClient.departmentId = this.departmentId;

    if (modelClient.document2?.trim() === "") modelClient.document2 = null;
    if (modelClient.names?.trim() === "") modelClient.names = null;
    if (modelClient.lastNames?.trim() === "") modelClient.lastNames = null;
    if (modelClient.businessName2?.trim() === "") modelClient.businessName2 = null;
    if (modelClient.comercialName?.trim() === "") modelClient.comercialName = null;
    if (modelClient.alterPhone?.trim() === "") modelClient.alterPhone = null;
    if (modelClient.email?.trim() === "") modelClient.email = null;
    if (modelClient.postalCode?.trim() === "") modelClient.postalCode = null;
    if (modelClient.observation?.trim() === "") modelClient.observation = null;
    if (modelClient.ciiuCode?.trim() === "") modelClient.ciiuCode = null;

    if (!modelClient.swIvaResponsible) {
      this.formClient.controls["swGreatContributor"].setValue(false);
      this.formClient.controls["swIvaRetainer"].setValue(false);
      modelClient.swGreatContributor = false;
      modelClient.swIvaRetainer = false;
    }

    if (!this.validateEmailService.validateEmails(this.formClient.get("email")?.value)) {
      this.disableNamesByTypePerson(this.formClient.get("typePersonId")?.value);
      return;
    }

    if (modelClient.typePersonId == TypePersonEnums.juridica && modelClient.typeDocumentId == TypeDocumentEnums.cedula) {
      this.toastHandlerService.showToast(
        'error',
        `El cliente tiene definido como Tipo Persona: JURÍDICA, el Tipo de Documento NO puede ser Ced.Ciudadanía.`
      );
      return;
    }

    if (!modelClient.swExpirationDays) {
      this.formClient.controls["expirationDays"].setValue(0);
      modelClient.expirationDays = 0;
    }

    if (this.clientContract.clientStateId !== modelClient.clientStateId) {
      try {
        const validateState = await firstValueFrom(
          this.clientService.validateStates(this.clientContract.clientId, modelClient.clientStateId));
        if (validateState.confirmation) {
          if (await this.confirmDialogService.confirm(validateState.message)) {
            const updateStateClientResponse = new UpdateStateClientResponseModel();
            updateStateClientResponse.clientId = this.clientContract.clientId;
            updateStateClientResponse.clientStateId = modelClient.clientStateId;
            updateStateClientResponse.updateConstructionSite = true;
            updateStateClientResponse.constructionSiteStateId = validateState.constructionSiteStateId;
            updateStateClientResponse.stateChangeDate = modelClient.stateChangeDate;
            if (this.clientContract.clientStateId !== modelClient.clientStateId &&
              this.isSameDate(this.clientContract.stateChangeDate, modelClient.stateChangeDate)) {
              updateStateClientResponse.stateChangeDate = this.dateConverterService.convertUtcToLocalDate(new Date());
            }
            try {
              const response = await firstValueFrom(
                this.clientService.updateClientAndConstructionSite(updateStateClientResponse)
              );
              this.toastHandlerService.showToast('success', response);
            } catch (error) {
              this.reloadClient(true);
              console.error('Error al actualizar el cliente y la obra.', error);
            }
          } else {
            if (validateState.updateClient) {
              try {
                this.clientContract = await firstValueFrom(
                  this.clientService.updateClient(this.clientContract)
                );
                this.validateForm(this.clientContract);
                this.updateFormState();
                this.toastHandlerService.showToast(
                  'success',
                  `El estado del cliente fue modificado exitosamente.`
                );
              } catch (error) {
                this.reloadClient(true);
                console.error('Error al modificar el estado del cliente.', error);
              }
            } else {
              this.reloadClient(true);
            }
          }
        } else {
          if (validateState.updateClient) {
            try {
              this.clientContract = await firstValueFrom(
                this.clientService.updateClient(this.clientContract)
              );
              this.validateForm(this.clientContract);
              this.updateFormState();
              this.toastHandlerService.showToast(
                'success',
                `El estado del cliente fue modificado exitosamente.`
              );
            } catch (error) {
              console.error('Error al modificar el estado del cliente.', error);
            }
          } else {
            this.toastHandlerService.showToast('error', validateState.message);
            this.reloadClient(true);
          }
        }
      } catch (error) {
        console.error('Error al validar el estado del cliente.', error);
      }
    }
    if (this.clientContract.clientId == 0) {
      try {
        this.clientContract = await firstValueFrom(this.clientService.createClient(modelClient));
        this.validateForm(this.clientContract);
        this.updateFormState();
        this.disableUpdateDocument = false;
        this.visibleState = true;
        this.visibleAdvancedOptions = true;

        if (await this.confirmDialogService.confirm(
          "¿Desea crear una obra y un c.costos para este nuevo Cliente?"
        )) {
          try {
            const constructionSite = await firstValueFrom(
              this.clientService.createConstructionSite(this.clientContract)
            );
            try {
              const costCenter = await firstValueFrom(
                this.constructionSiteService.createCostCenter(constructionSite)
              );
              this.toastHandlerService.showToast(
                'success',
                `La obra ${constructionSite.code} y el c.costos ${costCenter.code} fueron creados exitosamente.`
              );
            } catch (error) {
              this.toastHandlerService.showToast(
                'success',
                `La obra ${constructionSite.code} fue creada exitosamente, pero NO se pudo crear el c.costos correspondiente.`
              );
              console.error('Error al crear el c.costos.', error);
            }
          } catch (error) {
            console.error('Error al crear la obra.', error);
          }
        } else {
          this.toastHandlerService.showToast(
            'success',
            `El cliente fue creado exitosamente.`
          );
        }
      } catch (error) {
        console.error('Error al crear el cliente y la obra.', error);
      }
    } else {
      if (this.clientContract.clientStateId !== modelClient.clientStateId &&
        this.isSameDate(this.clientContract.stateChangeDate, modelClient.stateChangeDate)) {
        modelClient.stateChangeDate = this.dateConverterService.convertUtcToLocalDate(new Date());
      }
      this.clientContract.typeDocumentId = modelClient.typeDocumentId;
      this.clientContract.typePersonId = modelClient.typePersonId;
      this.clientContract.names = modelClient.names;
      this.clientContract.lastNames = modelClient.lastNames;
      this.clientContract.businessName = modelClient.businessName;
      this.clientContract.businessName2 = modelClient.businessName2;
      this.clientContract.comercialName = modelClient.comercialName;
      this.clientContract.address = modelClient.address;
      this.clientContract.phone = modelClient.phone;
      this.clientContract.alterPhone = modelClient.alterPhone;
      this.clientContract.departmentId = modelClient.departmentId;
      this.clientContract.cityId = modelClient.cityId;
      this.clientContract.email = modelClient.email;
      this.clientContract.taxEmail = modelClient.taxEmail;
      this.clientContract.postalCode = modelClient.postalCode;
      this.clientContract.observation = modelClient.observation;
      this.clientContract.clientStateId = modelClient.clientStateId;
      this.clientContract.stateChangeDate = modelClient.stateChangeDate;
      this.clientContract.swIvaResponsible = modelClient.swIvaResponsible;
      this.clientContract.swDeclarant = modelClient.swDeclarant;
      this.clientContract.swGreatContributor = modelClient.swGreatContributor;
      this.clientContract.swSimpleTaxRegime = modelClient.swSimpleTaxRegime;
      this.clientContract.swIvaRetainer = modelClient.swIvaRetainer;
      this.clientContract.swExpirationDays = modelClient.swExpirationDays;
      this.clientContract.ratePromptPayment = modelClient.ratePromptPayment;
      this.clientContract.kgQuota = modelClient.kgQuota;
      this.clientContract.ciiuCode = modelClient.ciiuCode;
      this.clientContract.expirationDays = modelClient.expirationDays;
      this.clientContract.currencyId = modelClient.currencyId;

      if (!this.clientContract.swExpirationDays) {
        this.formClient.controls["expirationDays"].setValue(0);
        this.clientContract.expirationDays = 0;
      }
      try {
        this.clientContract = await firstValueFrom(
          this.clientService.updateClient(this.clientContract)
        );
        this.validateForm(this.clientContract);
        this.updateFormState();
        this.toastHandlerService.showToast(
          'success',
          `El cliente fue modificado exitosamente.`
        );
      } catch (error) {
        console.error('Error al modificar el cliente.', error);
      }
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      typeDocumentId: {
        required: 'El campo Tipo Documento es obligatorio.',
        min: 'Debes seleccionar un Tipo Documento válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El Dígito de Verificación es obligatorio.',
        min: 'El valor mínimo del Dígito de Verificación es 1.',
        max: 'El valor máximo del Dígito de Verificación es 9.'
      },
      document2: {
        maxlength: 'El Documento 2 no puede tener más de 15 caracteres.'
      },
      digitVerification2: {
        min: 'El valor mínimo del Dígito de Verificación 2 es 1.',
        max: 'El valor máximo del Dígito de Verificación 2 es 9.'
      },
      stateChangeDate: {
        required: 'El campo Fecha Cambio Est. es obligatorio.'
      },
      clientStateId: {
        required: 'El campo Cambiar Estado es obligatorio.',
        min: 'Debes seleccionar un Estado válido.'
      },
      typePersonId: {
        required: 'El campo Tipo Persona es obligatorio.',
        min: 'Debes seleccionar un Tipo Persona válido.'
      },
      names: {
        maxlength: 'El campo Nombres no puede tener más de 75 caracteres.'
      },
      lastNames: {
        maxlength: 'El campo Apellidos no puede tener más de 75 caracteres.'
      },
      businessName: {
        required: 'El campo Razón Social es obligatorio.',
        maxlength: 'El campo Razón Social no puede tener más de 150 caracteres.'
      },
      businessName2: {
        maxlength: 'El campo Razón Social Alterna no puede tener más de 150 caracteres.'
      },
      comercialName: {
        maxlength: 'El campo Nombre Comercial no puede tener más de 100 caracteres.'
      },
      address: {
        required: 'El campo Dirección es obligatorio.',
        maxlength: 'El campo Dirección no puede tener más de 70 caracteres.'
      },
      phone: {
        required: 'El campo Teléfono es obligatorio.',
        minlength: 'El campo Teléfono debe tener al menos 7 caracteres.',
        maxlength: 'El campo Teléfono no puede tener más de 15 caracteres.'
      },
      alterPhone: {
        minlength: 'El Teléfono Alterno debe tener al menos 7 caracteres.',
        maxlength: 'El Teléfono Alterno no puede tener más de 15 caracteres.'
      },
      email: {
        email: 'El Correo no es válido.',
        maxlength: 'El campo Correo no puede tener más de 250 caracteres.'
      },
      taxEmail: {
        required: 'El campo Correo Fiscal es obligatorio.',
        email: 'El Correo Fiscal no es válido.',
        maxlength: 'El campo Correo Fiscal no puede tener más de 250 caracteres.'
      },
      observation: {
        maxlength: 'El campo Observación no puede tener más de 500 caracteres.'
      },
      ratePromptPayment: {
        min: 'La Tasa por Pronto Pago no puede ser menor a 0.',
        max: 'La Tasa por Pronto Pago no puede ser mayor a 100.'
      },
      kgQuota: {
        min: 'La Cuota en Kg no puede ser menor a 0.',
        max: 'La Cuota en Kg no puede ser mayor a 99,999,999.99.'
      },
      expirationDays: {
        min: 'Los Días de Vencimiento no pueden ser negativos.',
        max: 'Los Días de Vencimiento no pueden ser mayores a 32,767.'
      },
      currencyId: {
        required: 'El campo Moneda es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach(control => {
      const formControl = this.formClient.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async setCityDepartment(selectedItems: any) {
    const city = selectedItems[0];
    this.cityName = city.cityName;
    this.cityId = city.id;
    this.departmentName = city.departmentName;
    this.departmentId = city.departmentId;
  }

  updateFormPermision() {
    this.disabledForm = true;
    this.disableUpdateDocument = true;
    this.visibleState = true;
    this.visibleAdvancedOptions = true;
    setTimeout(() => this.formClient.disable(), 100);
    setTimeout(() => this.formControlStateService.setControlState(this.formClient,
      ['document', 'document2'], true), 100
    );
  }

  updateFormState(clientStateId?: number) {
    const selectedStateId = clientStateId ?? this.clientContract.clientStateId;
    const isActive = selectedStateId === ClientStateEnums.activo;
    if (isActive) {
      this.disabledForm = false;
      this.disableUpdateDocument = false;
      setTimeout(() => {
        this.formClient.enable();
        const valueControlActive = this.formClient.get("clientStateId")?.value === ClientStateEnums.activo;
        if (valueControlActive) {
          const typePersonId = this.formClient.get("typePersonId")?.value;
          this.disableNamesByTypePerson(typePersonId);
        }
        this.formControlStateService.setControlState(this.formClient,
          ['digitVerification', 'digitVerification2'], false
        );
      }, 100);
    } else {
      this.disabledForm = true;
      this.disableUpdateDocument = true;
      setTimeout(() => {
        this.formClient.disable();
        this.formControlStateService.setControlState(this.formClient,
          ['typeDocumentId', 'document', 'document2', 'stateChangeDate', 'clientStateId'], true
        );
      }, 100);
    }
  }

  updateInputsForSelectCityModal() {
    this.inputsForSelectCityModal$.next({
      headers: this.headersCitySelection,
      data: this.citySelectionData,
      filters: this.filtersCitySelection,
      showCheckbox: true,
      showRecover: true
    });
  }

  validateForm(client: ClientModel) {
    this.formClient = this.formBuilder.group({
      typeDocumentId: [client.typeDocumentId, [Validators.required, Validators.min(1)]],
      document: [client.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [client.digitVerification, [Validators.required, Validators.min(1), Validators.max(9)]],
      document2: [client.document2, [Validators.maxLength(15)]],
      digitVerification2: [client.digitVerification2, [Validators.min(1), Validators.max(9)]],
      stateChangeDate: [client.stateChangeDate ? this.dateConverterService.convertUtcToLocalDate(client.stateChangeDate) : null, [Validators.required]],
      clientStateId: [client.clientStateId, [Validators.required, Validators.min(1)]],
      typePersonId: [client.typePersonId, [Validators.required, Validators.min(1)]],
      names: [client.names, [Validators.maxLength(75)]],
      lastNames: [client.lastNames, [Validators.maxLength(75)]],
      businessName: [client.businessName, [Validators.required, Validators.maxLength(150)]],
      businessName2: [client.businessName2, [Validators.maxLength(150)]],
      comercialName: [client.comercialName, [Validators.maxLength(100)]],
      address: [client.address, [Validators.required, Validators.maxLength(70)]],
      phone: [client.phone, [Validators.required, Validators.minLength(7), Validators.maxLength(15)]],
      alterPhone: [client.alterPhone, [Validators.minLength(7), Validators.maxLength(15)]],
      departmentId: [],
      cityId: [],
      email: [client.email, [Validators.maxLength(250)]],
      taxEmail: [client.taxEmail, [Validators.required, Validators.email, Validators.maxLength(250)]],
      postalCode: [client.postalCode],
      observation: [client.observation, [Validators.maxLength(500)]],
      swIvaResponsible: [client.swIvaResponsible],
      swDeclarant: [client.swDeclarant],
      swGreatContributor: [client.swGreatContributor],
      swIvaRetainer: [client.swIvaRetainer],
      swSimpleTaxRegime: [client.swSimpleTaxRegime],
      ratePromptPayment: [client.ratePromptPayment, [Validators.min(0), Validators.max(100)]],
      kgQuota: [client.kgQuota, [Validators.min(0), Validators.max(99999999.99)]],
      ciiuCode: [client.ciiuCode, []],
      swExpirationDays: [client.swExpirationDays, []],
      expirationDays: [client.expirationDays, [Validators.min(0), Validators.max(32767)]],
      currencyId: [client.currencyId, [Validators.required]]
    });
    if (client.clientId != 0) {
      this.clientId = client.clientId;
      this.inputsForChangeDocumentModals$.next({ clientId: this.clientId, btnDisabled: this.disableUpdateDocument });
      this.location.replaceState(`/${this.url}/register/${this.clientId}`);
    }
  }

  validateFormControls() {
    Object.keys(this.formClient.controls).forEach((key) => {
      const control = this.formClient.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
